<template>
  <div id="containerContainer">
    <h3 id="players-heading">Players</h3>

    <div
      :key="user.playerSocketId"
      v-for="user in roomData.players"
      id="container"
    >
      <img
        :src="require('@/assets/images/' + user.avatar + '.png')"
        class="player-avatar"
      />
      <div
        v-if="user.playerSocketId === roomData.roomMaster.playerSocketId"
        class="li mainPlayer"
      >
        {{ user.playerName }} {{ user.score }}
        <img :src="require('@/assets/pen.png')" id="pen-image" />
      </div>
      <div v-else-if="user.playerSocketId === socketId" class="li">
        {{ user.playerName }}(You) {{ user.score }}
      </div>
      <div v-else class="li">{{ user.playerName }} {{ user.score }}</div>
    </div>
  </div>
</template>

<script>
import * as socketio from "../plugins/socketio";
export default {
  data() {
    return {
      roomData: "",
      socketId: socketio.clientSocketId(),
    };
  },
  name: "UserList",
  mounted() {
    socketio.addEventListener({
      type: "roomState",
      callback: (roomData) => {
        this.roomData = roomData;
      },
    });
  },
};
</script>

<style scoped>
.player-avatar {
  width: 40px;
  display: block;
  margin: auto;
}
#pen-image {
  width: 20px;
  height: 20px;
  margin-left: 10px;
}
.li {
  font-family: "Glory";
  display: block;
  margin: auto;
  font-weight: 600;
}
#container {
  display: flex;
  justify-content: center;
  align-items: center;
  float: left;
  background: tomato;
  width: 220px;
  border-radius: 10px;
  margin-bottom: 20px;
  list-style: none;
  list-style-type: none;
  height: 60px;
  margin: auto;
  margin-top: 10px;
}
#containerContainer {
  display: flex;
  flex-direction: column;
  float: left;
  list-style: none;
  list-style-type: none;
  background: white;
  width: 300px;
  height: 450px;
  margin-left: 10px;
  margin-top: 99px;
  border-radius: 10px;
  overflow-y: auto;
  padding-top: 10px;
}
#players-heading {
  text-align: center;
  font-family: "Poppins";
  color: black;
}
@media (max-width: 1200px) {
  #containerContainer {
    width: 27vw;
  }
}
@media (max-width: 500px) {
  #containerContainer {
    width: 100vw;
    height: 100vh;
    z-index: 4;
    float: none;
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
  }
  #players-heading {
    margin-bottom: 15vh;
    margin-top: 5vh;
  }
  #container {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0;
    margin-bottom: 20px;
  }
}
</style>
